module.exports = __webpack_public_path__ + "static/media/YearView.9e7c2428.svg";